import { validValue } from '@/model/common';
import { createReducerTypeSafe } from '@/utils/redux';

import {
  storeCache,
  storeCleanWithdrawal,
  StoreInitActionPayload,
  storeInitialized,
  storeLogout,
  storePhone,
  StorePhoneActionPayload,
  storeStep,
  StoreStepActionPayload,
  storeTiming,
  StoreTimingDataActionPayload,
  StoreTransferCacheActionPayload,
  storeWithdrawal,
  StoreWithdrawalDataActionPayload,
} from './actions';
import { initialState, State } from './types';

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storePhone,
    (state: State, phone: StorePhoneActionPayload): State => ({
      ...state,
      phone,
    }),
  ],
  [
    storeWithdrawal,
    (state: State, formData: StoreWithdrawalDataActionPayload): State => ({
      ...state,
      formData,
    }),
  ],
  [
    storeStep,
    (state: State, { status, sbpId, transactionId, step }: StoreStepActionPayload): State =>
      status === state.status && sbpId === state.sbpId && transactionId === state.transactionId && step === state.step
        ? state
        : {
            ...state,
            step,
            status,
            sbpId,
            transactionId,
          },
  ],
  [
    storeTiming,
    (state: State, { timing }: StoreTimingDataActionPayload): State => ({
      ...state,
      timing,
    }),
  ],
  [
    storeInitialized,
    (state: State, { status, sbpId, step, data }: StoreInitActionPayload): State => ({
      initialized: true,
      sbpId,
      step,
      transactionId: data?.transactionId,
      formData: data
        ? {
            id: data.id,
            receiver: data.receiver,
            receiverBanks: data.banks || [],
            bank: validValue(data.bankId),
            wallet: validValue(data.accountId),
            amount: validValue(data.amount),
            message: validValue(data.description),
            createdAt: data.createdAt,
            fee: data.fee,
          }
        : undefined,
      status,
      phone: validValue(data?.receiver.phone),
    }),
  ],
  [
    storeCache,
    (state: State, cache: StoreTransferCacheActionPayload): State => ({
      ...state,
      cache,
    }),
  ],
  [
    storeCleanWithdrawal,
    ({ sbpId, status, formData, step, transactionId, timing, cache, ...state }: State): State => state,
  ],
  [
    storeLogout,
    (): State => ({
      initialized: true,
    }),
  ],
]);

export default reducers;
